export const news = () => {
    const calendarToggle = '.js-toggle-calendar';
    const loadMoreLink = '.js-load-more-news';
    const newsContainer = '.js-news-container';
    const tagFilters = '.js-filter-tag';
    const dateFilters = '.js-filter-date';

    let filter_url = '';

    const limit = 10;

    let current_page = 0;
    let filter = {
        'limit': limit,
        'offset': 0,
        'tag': null,
        'date': null
    };

    const init = () => {
      filter_url = $('.js-news-container').data('url');
      bind();
      if($('.js-filter-tag.is-active').length > 0 && $('.js-filter-tag.is-active').data('tag') != '') {
        filter.tag = $('.js-filter-tag.is-active').data('tag');
        apply_filter(true);
      }
    };

    const bind = () => {
        $(tagFilters).on('click', change_tag);
        $(dateFilters).on('change', change_date);
        $(loadMoreLink).on('click', load_more);
    };

    const change_date = (e) => {
      e.preventDefault();
      reset_pagination();
      filter.date = $(e.currentTarget).val();
      apply_filter(true);
    };

    const change_tag = (e) => {
        e.preventDefault();
        reset_pagination();
        if($(e.currentTarget).hasClass('is-active')) {
          //If tag was already active, revert filter to 'all' on click.
          filter.tag = '';
          $(e.currentTarget).removeClass('is-active');
        } else {
          filter.tag = $(e.currentTarget).data('tag');
          $(e.currentTarget).addClass('is-active').siblings().removeClass('is-active');
        }
        apply_filter(true);
    };

    const reset_pagination = () => {
        filter.offset = 0;
        filter.limit = limit;
    }

    const load_more = (e) => {
        e.preventDefault();
        filter.offset = document.querySelectorAll(newsContainer + ' > *').length;
        apply_filter(false);
    };

    const apply_filter = (replace) => {
      
        console.log( filter_url + '.json?' + $.param(filter));

        $.ajax({
            url: filter_url + '.json?' + $.param(filter),
            dataType: 'json',
            success: function(response) {
                if(replace) {
                    if(response.html == '') {
                      $('#js-no-news').show();
                      $(newsContainer).addClass('is-empty');
                    } else {
                      $('#js-no-news').hide();
                      $(newsContainer).removeClass('is-empty');
                    }
                  $(newsContainer).html(response.html);
                } else {
                    $(newsContainer).append(response.html);
                }

                if(response.html == '' || response.more == false) {
                    $(loadMoreLink).hide();
                } else {
                    $(loadMoreLink).show();
                }
            }
        })
    };

    init();

};
